import { DateTime } from 'luxon';

export const getAdCampaignDuration = (startDate: string, endDate: string) => {
  const startDateObj = DateTime.fromISO(startDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const endDateObj = DateTime.fromISO(endDate).set({ hour: 11, minute: 59, second: 59, millisecond: 999 });
  const duration = endDateObj.diff(startDateObj, ['days']);
  const offsetDuration = duration.toObject().days ? duration.plus({ days: 1 }) : duration;
  return offsetDuration.toObject().days;
};
